__turbopack_context__.v({
  "scrollableTabs": "Hero-module__ZARIfG__scrollableTabs",
});
